import { FormlyFieldConfig } from '@ngx-formly/core';
import type { FormlyHookFn } from './formly-hook-fn.type';
import { getChildObject, getChildObjects, getFormRoot } from './form-data.utility';
import { startWith, switchMap, takeUntil } from 'rxjs/operators';
import { combineLatest, forkJoin, of } from 'rxjs';

export const internalDebug = (destroyed$) => {
    return (field: FormlyFieldConfig) => {
        field.formControl.events
            .pipe(takeUntil(destroyed$))
            .subscribe({
                next: (evt) => {
                    const x = evt;
                }
            });
        getParentAndSubscribe(field, field, destroyed$);
    }

}

function getParentAndSubscribe(debugField: FormlyFieldConfig, field: FormlyFieldConfig, destroyed$) {
    const valueChange = field.formControl.valueChanges;
    const statusChange = field.formControl.statusChanges

    valueChange.pipe(
        takeUntil(destroyed$)
    ).subscribe({
        next: (sc) => {
            const x = field; //here for debugging purposes
        },
        error: (err) => {console.log(`field ${field.key ? field.key : '-'} threw an error`);}
    });

    statusChange.pipe(
        takeUntil(destroyed$)
    ).subscribe({
        next: (sc) => {
            const status = `${field.formControl.status}`;
            const x = field; //here for debugging purposes
        },
        error: (err) => {console.log(`field ${field.key ? field.key : '-'} threw an error`);}
    });

    if(field.parent){
        getParentAndSubscribe(debugField, field.parent, destroyed$);
    }
}
